// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Qg","heading":"Rg"};